import { createContext } from "react";

export type I18NContextValues = {
  loading: boolean;
};

export const I18NContext = createContext<I18NContextValues | null>(null);
